<template>
<div class="payment_type">
    <img :src="CardICO" alt="card ico" :class="{'selected': value === 'card'}" v-if="getTypes('card')" @click="$emit('input','card')">
    <img :src="BanksICO" alt="banks ico" :class="{'selected': value === 'bank'}" v-if="getTypes('bank')" @click="$emit('input','bank')">
</div>
</template>
<script>
import BanksICO from '@/assets/bank.svg'
import CardICO from '@/assets/credit-card.svg'
export default {
  name: 'payment_type',
  components:{},
  data:()=>({
    BanksICO,
    CardICO,
  }),
  props:{
      value: {type: String},
  },
  computed:{
      payment_type(){
          return this.$store.getters.selectedTariff && this.$store.getters.selectedTariff.payment_type
      }
  },
  methods:{
      getTypes(item){
          if(item === 'card' && this.payment_type){
              return  this.payment_type.indexOf('Банковская карта') >=0 ? true : false
          }else if(item === 'bank' && this.payment_type){
              return this.payment_type.indexOf('на расчетный счет') >=0 ? true : false
          }

      }
  }
}
</script>
<style lang="sass" scoped>
.payment_type
    display: grid
    grid-template-columns: repeat(auto,90px)
    grid-gap: 20px
    justify-content: center
    img
        height: 90px
        border: 1px solid transparent
        border-radius: 15px
        padding: 10px
        &:hover
            border: 1px solid var(--v-primary-base)
            cursor: pointer
        &.selected
            border: 1px solid var(--v-primary-base)
            background-color: var(--v-primary-base)
</style>
